import { Typography } from "@mui/material";
import styled from "@mui/material/styles/styled";

import TableCell from "@app/analytics/components/Table/TableCell";
import TableRow from "@app/analytics/components/Table/TableRow";
import { pluralizePhrase } from "@app/common/utils";

import { Column } from "@rui/Stack";

const StyledCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: theme.palette.shades.neutral[50],
  padding: "4px 20px !important",
  height: "auto !important",
  color: theme.palette.shades.neutral[500],
  textAlign: "center",
}));

const ParticipantsNotShownRow = ({
  numHiddenParticipants,
}: {
  numHiddenParticipants: number;
}) => (
  <TableRow>
    <StyledCell colSpan={3}>
      <Column>
        <Typography variant="label1" sx={{ fontWeight: 500 }}>
          {pluralizePhrase(numHiddenParticipants, "participant")} not shown
        </Typography>
        <Typography variant="label1">
          With 7+ participants, Read only shows the highest and lowest scores.
        </Typography>
      </Column>
    </StyledCell>
  </TableRow>
);

export default ParticipantsNotShownRow;
